import { Component, Input, OnInit } from '@angular/core';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';

@Component({
  selector: 'app-display-rubrique-status-with-warning',
  templateUrl: './display-rubrique-status-with-warning.component.html',
  styleUrls: ['./display-rubrique-status-with-warning.component.scss'],
  standalone: true,
  imports: [IonItem, IonLabel, IonList],
})
export class DisplayRubriqueStatusWithWarningComponent {
  @Input() title: string = '';
  @Input() warning: boolean = false;
  @Input() icon: string = '';
  @Input() text: string = '';

  constructor() {}
}
